import styled from 'styled-components';
import { BREAK_POINTS } from '../../consts/styleDedupe';
import { COLOURS, FadeUpVariable } from '../../consts/style';
import { TrackedLink } from '@origin-digital/ods-core';

export const FlexContainer = styled.div`
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  @media (min-width: ${BREAK_POINTS.Min.LG}) {
    max-width: inherit;
    flex-flow: row;
    justify-content: space-between;
  }

  & > * {
    flex: 1;

    @media (min-width: ${BREAK_POINTS.Min.LG}) {
      flex: 0 0 calc(33% - ${(66 * 2) / 3}px);
    }

    @media (min-width: ${BREAK_POINTS.Min.XL}) {
      flex: 0 0 calc(33% - ${(1108 - 320 * 3) / 3}px);
    }
  }

  & > *:not(:last-child) {
    margin-bottom: 48px;

    @media (min-width: ${BREAK_POINTS.Min.LG}) {
      margin-bottom: 0;
    }
  }
  & > a:nth-child(1) > div {
    ${FadeUpVariable({ duration: '0', pause: '0' })}
  }
  & > div:nth-child(2),
  & > a:nth-child(2) > div {
    ${FadeUpVariable({ duration: '1.2', pause: '20' })}
  }
  & > div:nth-child(3),
  & > a:nth-child(3) > div {
    ${FadeUpVariable({ duration: '1.6', pause: '40' })}
  }
`;

export const UnstyledLink = styled(TrackedLink)`
  text-decoration: none;

  & [data-id='why-origin-text-link'] {
    display: inline;
    width: auto;
    padding: 12px 8px;
    font-weight: 600;
    color: ${COLOURS.PRIMARY.RED};
    margin: -12px 0 0 -8px;
  }

  // style buttons and links on hover
  &:hover [data-id='why-origin-text-link'] {
    background-color: ${COLOURS.PRIMARY.RED_LIGHT};
  }

  &:hover [data-id='why-origin-text'] u {
    color: ${COLOURS.PRIMARY.RED};
    text-decoration: none;
  }
`;
